<template>
    <div class="card mb-3">
        <div class="card-body">
            <Loading v-if="showLoading" />
            <div class="row">
                <div class="col-md-2">
                    <label><label style="color: red; height: 2px;" >*</label>
                        از تاریخ</label>
                    <Datepicker simple auto-submit id="from-date" locale="fa" input-format="YYYY-MM-DD" :max="today" v-model="fromDate" :locale-config="{
                        fa: {
                            displayFormat: 'jYYYY/jMM/jDD',
                            lang: {label: 'شمسی'}
                        }
                    }" />
                </div>
                <div class="col-md-2">
                    <label><label style="color: red; height: 2px;" >*</label>
                        تا تاریخ</label>
                    <Datepicker simple auto-submit id="to-date" locale="fa" input-format="YYYY-MM-DD" :min="fromDate" :max="today" v-model="toDate" :locale-config="{
                        fa: {
                            displayFormat: 'jYYYY/jMM/jDD',
                            lang: {label: 'شمسی'}
                        }
                    }" />
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label>لیست شرکت ها</label>
                        <select class="form-control" v-model="projectId">
                            <option v-for="(project,index) in projects" :value="project.id" :key="index">{{ project.title }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label>سرویس دهنده های پستی</label>
                        <select class="form-control" v-model="typeId">
                            <option v-for="(type,index) in types" :value="type.id" :key="index">{{ type.title }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4" style="margin-top: 29px;">
                    <button class="btn btn-primary btn-block" @click="submit" :disabled="!fromDate || !toDate">
                        <i class="si si-magnifier"></i>
                        جستجو
                    </button>
                </div>
            </div>
            <div class="alert alert-info mt-4 mb-0" v-if="!rows.length && isSearched">
                <p class="mb-0">اطلاعاتی یافت نشد</p>
            </div>
            <hr v-if="rows.length">
            <table class="table table-hover table-bordered mb-0" v-if="rows.length">
                <thead>
                    <tr>
                        <th>نام شرکت</th>
                        <th>تاریخ درخواست</th>
                        <th>تاریخ انجام</th>
                        <th>کد رهیابی</th>
                        <th>وضعیت</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row,index) in rows" :key="index">
                        <td>{{ row.projectId }}</td>
                        <td dir="ltr">{{ row.requestDate }}</td>
                        <td dir="ltr">{{ row.chargeDate }}</td>
                        <td>{{ row.code }}</td>
                        <td>{{ row.ype }}</td>
                    </tr>
                </tbody>
            </table>
            <div class="row mt-3" v-if="pages.length > 1" style="overflow-x: hidden;">
                <div class="col-12" style="overflow-x: auto;">
                    <ul class="pagination pagination-circled">
                        <li class="page-item" v-if="currentPage > 1">
                            <a class="page-link" href="#" v-on:click="currentPage--"><i class="icon ion-ios-arrow-forward"></i></a>
                        </li>
                        <li :class="currentPage == page ? 'page-item active' : 'page-item'" v-for="page in pages" :key="page">
                            <a class="page-link" href="#" v-on:click="currentPage = page">{{ page }}</a>
                        </li>
                        <li class="page-item" v-if="pages.length != currentPage">
                            <a class="page-link" href="#" v-on:click="currentPage++"><i class="icon ion-ios-arrow-back"></i></a>
                        </li>
                    </ul>
                </div>
            </div>
            <p v-if="rows.length" class="mt-4 mb-0">تعداد کل : {{ count }}</p>
        </div>
    </div>
</template>

<script>
import moment from 'moment-jalaali';
export default {
    name: 'CustomerReport',
    data(){
        return {
            showLoading: false,
            isSearched: false,
            projects: [],
            types:[{id: 0 , title :"پست"},{id: 1 , title :"اکسپرس"}],
            rows: [],
            fromDate: '',
            toDate: '',
            currentPage: 1,
            pages: [1],
            perPage: 10,
            today: moment().format('jYYYY-jMM-jDD'),
            showCard: false,
            count: 0,
            typeId:0
        }
    },
    watch: {
        currentPage(value){
            this.currentPage = value;
            this.getData();
        }
    },
    methods: {
        getData(){
            this.showLoading = true;
            const postedData = {
                fromDate: this.fromDate.replace(/\//g,''),
                toDate: this.toDate.replace(/\//g,''),
                projectId:this.projectId,
                typeId: this.typeId
            };
            this.row=[];
            this.$api.post('Organizations/Bonus/SearchChargeOrders',postedData).then(({data}) => {
                if(data.status){
                    this.rows = data.result.result;
                    this.count = data.result.totalCount;
                    let calcPages = Math.ceil(this.count / this.perPage);
                    calcPages = calcPages > 1 ? calcPages : 1
                    let pagesArray = [];
                    for(let i = 1;i <= calcPages;i++)
                        pagesArray.push(i);
                    this.pages = pagesArray;
                }else{
                    this.rows = [];
                }
            }).finally(() => {
                this.isSearched = true;
                this.showLoading = false;
                if(this.pan){
                    this.showCard = true;
                }
            });
        },
        submit(){
            this.getData();
        }
    },
    created() {
        //TODO Nasrin : update URL and cels data
            this.$api.get('Project/GetAllProject').then(({ data }) => {
                if(data.status)
                    this.projects = data.result;
            });
        }, 
}
</script>